import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Box } from '@material-ui/core';
import {
  dnaBasedLevelLow,
  dnaBasedLevelModerate,
  dnaBasedLevelHigh,
} from 'on_web/assets/imageList';
import { Trans, useTranslation } from 'react-i18next';
import { LOW_RISK_COLOR, MODERATE_RISK_COLOR, HIGH_RISK_COLOR } from 'colours';

/**
 * Component displaying summary for DNA based risk.
 *
 * @param {Component properties} props
 */
export default function DnaBasedRiskSummary(props) {
  const { t } = useTranslation();

  /**
   * Gets a proper image based on user's risk value.
   */
  const getImage = () => {
    return (
      <img
        src={
          props.riskValue === 0
            ? dnaBasedLevelLow
            : props.riskValue === 1
            ? dnaBasedLevelModerate
            : dnaBasedLevelHigh
        }
        height={props.isDesktop ? '120px' : '80px'}
        alt="Risk illustration"
      ></img>
    );
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-around"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography
            style={{
              fontFamily: 'MuseoSans-500',
              fontSize: props.isDesktop ? '28px' : '20px',
              color:
                props.riskValue === 0
                  ? LOW_RISK_COLOR
                  : props.riskValue === 1
                  ? MODERATE_RISK_COLOR
                  : HIGH_RISK_COLOR,
            }}
          >
            <Trans
              i18nKey="reporting.dnaRisksByCategory.overallRiskMessage"
              values={{
                riskLevelLabel: t(props.dnaRiskText)
                  .toUpperCase()
                  .bold(),
              }}
            />
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justify={props.isDesktop ? 'space-around' : 'flex-start'}
        alignItems="flex-end"
        style={{ paddingTop: 20, paddingBottom: 20 }}
      >
        <Grid item xs={6}>
          <Typography
            style={{
              fontFamily: 'Museo-500',
              fontSize: props.isDesktop ? '18px' : '14px',
              fontWeight: 500,
            }}
          >
            {t('reporting.myAssessment.dnaBasedRiskExplanation')}
          </Typography>
        </Grid>
        <Grid item xs={6} px={2}>
          <Box display="flex" justifyContent="center">
            {getImage()}
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

DnaBasedRiskSummary.propTypes = {
  /**
   * Indicates Desktop resolution.
   */
  isDesktop: PropTypes.bool.isRequired,

  /**
   * DNA risk.
   */
  riskValue: PropTypes.number.isRequired,
};
